
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'ScannerMessageOverlay',
})
export default class ScannerMessageOverlay extends Vue {
  @Prop({ type: Array, default: () => [] }) errorLines!: string[]
}
